import {CustomersHttp} from "@/http/CustomersHttp";

export default {
    async setCustomers({commit}) {
        const customers = await CustomersHttp.getAllCustomers().then(customers => customers.data);
        commit('setCustomers', customers);
    },
    async filterCustomers({commit}, q) {
        const customers = await CustomersHttp.searchForCustomer(q).then(customers => customers.data);
        commit('setCustomers', customers);
    },
    setActiveCustomer({commit}, customer) {
        commit('setActiveCustomer', customer);
    },
    setManageCustomerDialog({commit}, status) {
        commit('setManageCustomerDialog', status);
    },
    setDeleteCustomerDialog({commit}, status) {
        commit('setDeleteCustomerDialog', status);
    }
}
